import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import DevTools from 'mobx-react-devtools';
import { hot } from 'react-hot-loader';
import uiState from './state/uiState';
import { observer } from 'mobx-react';

import TimerView from './TimerView';

@observer
class App extends Component {
  constructor() {
    super();
  }

  render() {
    return <TimerView />;
  }
}

export default hot(module)(App);
